export default "__VITE_ASSET__CPEBngUO__"